import React from "react"
import PageHeader from "../components/Ui/Page/PageHeader"

export const Error404Page = () => {
  return <PageHeader title="404 | Page not found" description="The page you looking for does not exist." />
}
